import { gql } from 'graphql-tag'

const checklistItemFragment = gql`
  fragment ChecklistItemFragment on ChecklistItem {
    id
    description
    type
    shiftStatus {
      morning
      evening
      night
    }
    station {
      id
    }
    days
  }
`

export const continuingChecklistItemFragment = gql`
  fragment ContinuingChecklistItemFragment on ContinuingChecklistItem {
    id
    description
    station {
      id
    }
    type
    interval
  }
`

export const checklistItemsQuery = gql`
  query ChecklistItems {
    checklistItems {
      total
      edges {
        node {
          ...ChecklistItemFragment
        }
      }
    }
    continuingChecklistItems {
      ...ContinuingChecklistItemFragment
    }
  }
  ${checklistItemFragment}
  ${continuingChecklistItemFragment}
`
export const fetchStationChecklistItems = gql`
  query FetchStationChecklistItems($stationId: ID!) {
    stationChecklistsItems(stationId: $stationId) {
      total
      edges {
        node {
          ...ChecklistItemFragment
        }
      }
    }
    continuingChecklistItems(stationId: $stationId) {
      ...ContinuingChecklistItemFragment
    }
  }
  ${checklistItemFragment}
  ${continuingChecklistItemFragment}
`

export const createChecklistItemMutation = gql`
  mutation CreateChecklistItem($checklistItem: CreateChecklistItemInputType!) {
    createChecklistItem(checklistItem: $checklistItem) {
      ...ChecklistItemFragment
    }
  }
  ${checklistItemFragment}
`

export const updateChecklistItemMutation = gql`
  mutation UpdateChecklistItem($id: ID!, $checklistItem: UpdateChecklistItemInputType!) {
    updateChecklistItem(checklistItemId: $id, checklistItem: $checklistItem) {
      ...ChecklistItemFragment
    }
  }
  ${checklistItemFragment}
`

export const deleteCheckListItemMutation = gql`
  mutation DeleteChecklistItem($id: ID!) {
    deleteChecklistItem(checklistItemId: $id)
  }
`

export const createContinuingChecklistItemMutation = gql`
  mutation CreateContinuingChecklistItem($checklistItem: CreateContinuingChecklistItemInputType!) {
    createContinuingChecklistItem(continuingChecklistItem: $checklistItem) {
      ...ContinuingChecklistItemFragment
    }
  }
  ${continuingChecklistItemFragment}
`

export const updateContinuingChecklistItemMutation = gql`
  mutation UpdateContinuingChecklistItem($id: ID!, $checklistItem: UpdateContinuingChecklistItemInputType!) {
    updateContinuingChecklistItem(continuingChecklistItemId: $id, continuingChecklistItem: $checklistItem) {
      ...ContinuingChecklistItemFragment
    }
  }
  ${continuingChecklistItemFragment}
`

export const deleteContinuingChecklistItemMutation = gql`
  mutation DeleteContinuingChecklistItem($id: ID!) {
    deleteContinuingChecklistItem(continuingChecklistItemId: $id)
  }
`
